module.exports = __webpack_public_path__ + "static/media/BasisGrotesque-Regular.36a36433.ttf";